import { OrgSectionVisibilityModel } from "catchment-common/entities/organisationDashboard";

import { useOrgData } from "./useOrgData";

/**
 * Which Insights sections the organisation sidebar should offer — on when at
 * least one project/package pair the org can see carries commitments of that
 * type on BOTH sides, the same rule the project sidebar applies.
 *
 * Opts out of both header filters. The Project Scope one because navigation is
 * not a figure: narrowing a chart to one project must not remove the links to
 * the others' sections. The period for the same reason — a section exists
 * because commitments were made, not because they were reported inside the
 * window currently on screen.
 */
export const useOrgSectionVisibility = () =>
  useOrgData<OrgSectionVisibilityModel>("getSectionVisibility", {
    ignorePeriodFilter: true,
    ignoreProjectFilter: true
  });
